import { render, staticRenderFns } from "./Reporteequipo.vue?vue&type=template&id=22c0cc21&"
import script from "./Reporteequipo.vue?vue&type=script&lang=js&"
export * from "./Reporteequipo.vue?vue&type=script&lang=js&"
import style0 from "./Reporteequipo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports